export default __webpack_public_path__ + "static/media/loader.b2dd69ed.gif";